/* unplugin-vue-components disabled */import { render } from "./photoSphereViewer.vue?vue&type=template&id=2e4bee2a&scoped=true"
import script from "./photoSphereViewer.vue?vue&type=script&lang=js"
export * from "./photoSphereViewer.vue?vue&type=script&lang=js"

import "./photoSphereViewer.vue?vue&type=style&index=0&id=2e4bee2a&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4bee2a"]])

export default __exports__